import {Injectable} from "@angular/core";
import {HttpObservable, HttpWrapper} from "../http-helpers/http.wrapper";

/**
 ****************************************************************
 * Proxy service class theme management.
 *
 * Created by Shai Zelman on 06/06/2020.
 ****************************************************************
 */
@Injectable({
	providedIn: "root"
})
export class ThemeProxy {
	constructor(private httpWrapper: HttpWrapper) {

	}

	public getTheme(): HttpObservable<any> {
		return this.httpWrapper.getAnon("PatientPortalTheme", "GetTheme");
	}
}
